import '../styles/gifthub.scss';
import initPageChrome from './page-chrome';

document.addEventListener('DOMContentLoaded', initPageChrome);
